import { html, nothing } from "lit";
import { ActivityHistoryBusy } from "./component";
import { translate } from "../../../../localization";

export const template = (props: ActivityHistoryBusy) =>
  props.isEmptyDataAndOtherLoading
    ? html`<div class="skeleton-container">${props.skeletons}</div>`
    : props.isSomeCollectionLoadedAndOtherLoading
      ? html`<div class="spinner-container"><dss-spinner size="sm"></dss-spinner><div class="busy-description">${translate("busyEntriesLoading")}</div></div>`
      : nothing;
